import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useArchivedDocumentImagesInfiniteQueryKey } from './useArchivedDocumentImagesInfiniteQueryKey'

export const useInvalidateArchivedDocumentImagesInfiniteQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useArchivedDocumentImagesInfiniteQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
